import React, { useContext, useEffect, createContext, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Navigate,
} from "react-router-dom";
//  HashRouter
import { AuthProvider, AuthContext } from "./context/AuthContext";
// Import enhanced route protection components
import {
  PublicRoute,
  BasicUserRoute,
  PremiumUserRoute,
  // ProtectedRoute,
  // PaidPremiumRoute,
} from "./components/RouteProtection";

import "./App.css";
import axios from "axios";
import Home from "./Home";
import Main from "./Main";
import Learnsql from "./Learnsql";
import Register from "./Register";
import Login from "./Login";
import Pricing from "./Pricing";
import Changepassword from "./Changepassword";
import Checkout from "./Checkout";
import SubscribersMain from "./SubscribersMain";
import QuestionsOverview from "./QuestionsOverview";
import ReactGA from "react-ga";
import TermsandCondition from "./TermsandCondition";
import Privacy from "./Privacy";
import Profile from "./Profile";
import CasestudyCards from "./CasestudyCards";
import CourseCertificate from "./CourseCertificate";
import PaddlePaymentForm from "./PaddlePaymentForm";
import PaymentSuccess from "./PaymentSuccess";
import GoogleCallback from "./GoogleCallback";
import CookieChecker from "./CookieChecker";
import AuthTester from "./AuthTester";
import AppWrapper from "./components/AppWrapper";

// Initialize Google Analytics with your tracking code
ReactGA.initialize("UA-XXXXXXXXX-X");

// Add this line to track the initial pageview
ReactGA.pageview(window.location.pathname + window.location.search);

const URL = "https://sqlguroo.com";

axios.defaults.baseURL = "https://sqlguroo.com";
axios.defaults.withCredentials = true;
axios.defaults.headers.common["Content-Type"] = "application/json";

// Route protection functions moved to ./components/RouteProtection.js

function App() {
  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await fetch(`${URL}/auth/check-session`, {
          credentials: "include",
        });
        // console.log(response)
        if (response.status === 401) {
          localStorage.removeItem("userId");
          // window.location.href = '/login';
        }
      } catch (error) {
        console.error("Failed to check session", error);
      }
    };

    const intervalId = setInterval(checkSession, 1800000); // Check every 30 minutes

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  return (
    <AuthProvider>
      <Router>
        <AppWrapper>
          <div>
            <Routes>
              {/* {user ? <Chatwindow /> : <Login />} */}
              <Route path="/" element={<Home />} />
              <Route path="/question/:id" element={<Main />} />
              {/* <Route exact path="/chatwindow" element={user ? <Chatwindow /> : <Navigate to="/Login" />} /> */}
              {/* <Route exact path="/chatwindow" element={<Chatwindow />} /> */}
              {/* default redirect to home page */}
              {/* <Route path="/learnsql/:id" element={<Learnsql />} /> */}
              {/* <Route path="/learnsql/:id" element={<Learnsql />} /> */}

              <Route
                path="/terms"
                element={
                  <PublicRoute
                    allowIfLoggedIn={true}
                    element={<TermsandCondition />}
                  />
                }
              />

              <Route
                path="/privacy"
                element={
                  <PublicRoute allowIfLoggedIn={true} element={<Privacy />} />
                }
              />

              <Route
                path="/cookiechecker"
                element={
                  <PublicRoute
                    allowIfLoggedIn={true}
                    element={<CookieChecker />}
                  />
                }
              />
              <Route
                path="/authtester"
                element={
                  <PublicRoute
                    allowIfLoggedIn={true}
                    element={<AuthTester />}
                  />
                }
              />

              <Route
                path="/question/:id"
                element={
                  <PublicRoute allowIfLoggedIn={true} element={<Main />} />
                }
              />

              <Route
                path="/learnsql/:id"
                element={
                  <BasicUserRoute
                    allowIfLoggedIn={true}
                    element={<Learnsql />}
                  />
                }
              />

              <Route
                path="/subscribersmain/:id"
                element={
                  <PremiumUserRoute
                    // allowIfLoggedIn={true}
                    element={<SubscribersMain />}
                  />
                }
              />

              <Route
                path="/questionsoverview"
                element={<PremiumUserRoute element={<QuestionsOverview />} />}
              />

              <Route
                path="/pricing"
                element={
                  <PublicRoute allowIfLoggedIn={true} element={<Pricing />} />
                }
              />

              <Route
                path="/register"
                element={
                  <PublicRoute allowIfLoggedIn={true} element={<Register />} />
                }
              />
              <Route
                path="/login"
                element={
                  <PublicRoute allowIfLoggedIn={true} element={<Login />} />
                }
              />

              <Route
                path="/auth/google/callback"
                element={
                  <PublicRoute
                    allowIfLoggedIn={true}
                    element={<GoogleCallback />}
                  />
                }
              />

              <Route
                path="/checkout"
                element={
                  <PremiumUserRoute
                    allowIfLoggedIn={true}
                    element={<Checkout />}
                  />
                }
              />

              <Route
                path="/changepassword"
                element={<PremiumUserRoute element={<Changepassword />} />}
              />

              <Route
                path="/profile"
                element={<BasicUserRoute element={<Profile />} />}
              />

              <Route
                path="/casestudycards"
                element={<PublicRoute element={<CasestudyCards />} />}
              />

              <Route
                path="/coursecertificate"
                element={
                  <PublicRoute
                    allowIfLoggedIn={true}
                    element={<CourseCertificate />}
                  />
                }
              />

              <Route
                path="/payment"
                element={
                  <BasicUserRoute
                    // allowIfLoggedIn={true}
                    element={<PaddlePaymentForm />}
                  />
                }
              />
              <Route
                path="/paymentsuccess"
                element={<BasicUserRoute element={<PaymentSuccess />} />}
              />

              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </div>
        </AppWrapper>
      </Router>
    </AuthProvider>
  );
}

export default App;
